import React, { Dispatch } from "react"

import { BankRateTable } from "components/organisms/panel/tableList"
import { APIResponse } from "redux/apis/types"
import { usePriceListAction } from "components/actions/priceList"
import { MainContainer } from "components/molecules/utils/mainContainer"

type BankRateTemplateType = {
  bankRateList: APIResponse.Res
  bankRateAction: Dispatch<usePriceListAction>
}

export const BankRateTemplate: React.FC<BankRateTemplateType> = props => {
  return (
    <MainContainer className="symmetry-layout">
      <div className="contents-block">
        <BankRateTable
          list={props.bankRateList}
          reload={() => props.bankRateAction({ type: "PRICE_LIST_RELOAD" })}
        />
      </div>
    </MainContainer>
  )
}
